import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Sun, Feather, Leaf, BookOpen, Sparkles } from 'lucide-react';
import { SectionEyebrow } from './SectionEyebrow';
import { CTAButton } from './CTAButton';
const pilares = [{
  num: '01',
  icon: Heart,
  title: 'Sanación emocional y autoestima',
  description: 'Herramientas para liberar el pasado y sanar el autoconcepto.'
}, {
  num: '02',
  icon: Sun,
  title: 'Autoestima e identidad',
  description: 'Reconstruye la forma en la que te miras, te hablas y te tratas.'
}, {
  num: '03',
  icon: Leaf,
  title: 'Hábitos para tu nueva versión',
  description: 'Rutinas y hábitos diseñados para ayudarte a sostener la vida y la mujer que deseas construir.'
}, {
  num: '04',
  icon: Feather,
  title: 'Feminidad consciente',
  description: 'Aprende a reconectar con tu energía femenina y elevar tus estándares.'
}, {
  num: '05',
  icon: Sparkles,
  title: 'Espiritualidad y conexión con Dios',
  description: 'Fortalece tu relación con Dios y convierte tu fe en una parte fundamental de tu crecimiento personal.'
}, {
  num: '06',
  icon: BookOpen,
  title: 'Ruptura de patrones',
  description: 'Claridad absoluta para dejar de repetir patrones.'
}];
export function Pilares() {
  return <section className="py-24 md:py-32 px-6 bg-card relative" data-id="element-175">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-[0.02] mix-blend-multiply pointer-events-none" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
    }} data-id="element-176"></div>

      <div className="container max-w-[1200px] mx-auto relative z-10" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-178">
          <SectionEyebrow text="Lo que vas a transformar" className="mb-6" data-id="element-179" />
          <h2 className="text-4xl md:text-5xl text-foreground" data-id="element-180">
            Seis pilares para tu{' '}
            <span className="italic text-muted-foreground" data-id="element-181">nueva versión</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-8 md:gap-y-12" data-id="element-182">
          {pilares.map((pilar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group relative bg-background p-10 rounded-2xl border border-border/40 hover:border-border transition-all duration-500 hover:shadow-soft hover:scale-[1.01]" data-id="element-183">
              {/* Gold hairline top */}
              <div className="absolute top-0 left-10 right-10 h-[1px] bg-accent/30 group-hover:bg-accent/60 transition-colors duration-500" data-id="element-184"></div>

              <div className="flex items-center justify-between mb-8" data-id="element-185">
                <span className="font-serif italic text-2xl text-accent/80" data-id="element-186">
                  {pilar.num}
                </span>
                <pilar.icon className="w-5 h-5 text-muted-foreground/50 group-hover:text-accent transition-colors duration-500" strokeWidth={1.5} data-id="element-187" />
              </div>

              <h3 className="font-serif text-3xl text-foreground mb-4 leading-tight" data-id="element-188">
                {pilar.title}
              </h3>
              <p className="text-muted-foreground font-light leading-relaxed" data-id="element-189">
                {pilar.description}
              </p>
            </motion.div>)}
        </div>

        <div className="flex justify-center mt-16" data-id="element-190">
          <CTAButton text="Quiero trabajar estos pilares" data-id="element-191" />
        </div>
      </div>
    </section>;
}